import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enCommon from "./locales/en/common.json";
import svCommon from "./locales/sv/common.json";

const resources = {
  en: { common: enCommon },
  sv: { common: svCommon },
} as const;

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: "sv",
  supportedLngs: ["en", "sv"],
  defaultNS: "common",
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  detection: {
    order: ["path", "localStorage"],
    caches: ["localStorage"],
  },
});

export type Resources = typeof resources;
declare module "i18next" {
  interface CustomTypeOptions {
    resources: Resources;
  }
}

export default i18n;
